import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";
import { ProfileCashierAddButtonHarrahsWsopBox } from "./profile-cashier-add-button.harrahswsop.box";
import { ProfileCashierAddButtonDefaultBox } from "./profile-cashier-add-button.default.box";

export const ProfileCashierAddButtonBox = styledByTheme(ProfileCashierAddButtonDefaultBox)
    .forHarrahs(ProfileCashierAddButtonHarrahsWsopBox)
    .forWsop(ProfileCashierAddButtonHarrahsWsopBox)
    .apply();
